import {
  CategoriesRequest,
  CreateCategoryRequest,
  GetCategoryRequest,
  UpdateCategoryRequest,
  DeleteCategoryRequest,
} from '../api/requests';
import type { UserStore } from '~/authentication/stores/user';
import type ApiClient from '~/common/services/ApiClient';
import type { RequestPagination } from '~/common/types';
import type { Category } from '~/categories/types';

export class CategoryService {
  apiClient: ApiClient;
  userStore: UserStore;

  constructor(apiClient: ApiClient, userStore: UserStore) {
    this.apiClient = apiClient;
    this.userStore = userStore;
  }

  async fetch(pagination: RequestPagination, params: Record<string, any>) {
    const accessToken = this.userStore.accessToken;
    const request = new CategoriesRequest({
      token: accessToken,
      params: { ...pagination, ...params },
    });

    return this.apiClient.request(request);
  }

  async get(id: Category['id'], params: Record<string, any>) {
    const accessToken = this.userStore.accessToken;
    const request = new GetCategoryRequest({
      token: accessToken,
      id,
      params: { ...params },
    });

    return this.apiClient.request(request);
  }

  async create(category: Category) {
    const accessToken = this.userStore.accessToken;
    const request = new CreateCategoryRequest({
      token: accessToken,
      category,
    });

    return this.apiClient.request(request);
  }

  async update(category: Category) {
    const accessToken = this.userStore.accessToken;
    const request = new UpdateCategoryRequest({
      token: accessToken,
      category,
    });

    return this.apiClient.request(request);
  }

  async delete(id: Category['id']) {
    const accessToken = this.userStore.accessToken;
    const request = new DeleteCategoryRequest({
      token: accessToken,
      id,
    });

    return this.apiClient.request(request);
  }
}
